import { inject, Injectable } from '@angular/core';
import { ApiDataAccess } from '@softline/core';
import {
  SOFTLINE_API_CASH_REGISTER_END_OF_DAY_CASHIER,
  SOFTLINE_API_CASH_REGISTER_END_OF_DAY_CASHIERS,
  SOFTLINE_API_CASH_REGISTER_END_OF_DAY_CHECK,
  SOFTLINE_API_CASH_REGISTER_END_OF_DAY_DELETE,
  SOFTLINE_API_CASH_REGISTER_END_OF_DAY_ENTITIES,
  SOFTLINE_API_CASH_REGISTER_END_OF_DAY_FINALIZE,
  SOFTLINE_API_CASH_REGISTER_END_OF_DAY_FINALIZE_TERMINAL,
  SOFTLINE_API_CASH_REGISTER_END_OF_DAY_PRINT,
  SOFTLINE_API_CASH_REGISTER_END_OF_DAY_VALIDATE,
} from '@softapps/wws/pos-core';
import { EndOfDay, EndOfDayValidateResult } from '../types/end-of-day';
import { Cashier } from '../types/cashier';

@Injectable()
export class EndOfDayRepository {
  readonly #dataAccess = inject(ApiDataAccess);

  async check(): Promise<{ possible: boolean; reason: string }> {
    return this.#dataAccess.create(
      {
        path: SOFTLINE_API_CASH_REGISTER_END_OF_DAY_CHECK,
      },
      {}
    );
  }

  async getCashiers(): Promise<Cashier[]> {
    return this.#dataAccess.get({
      path: SOFTLINE_API_CASH_REGISTER_END_OF_DAY_CASHIERS,
    });
  }

  async getEndOfDay(): Promise<EndOfDay> {
    return this.#dataAccess.get({
      path: SOFTLINE_API_CASH_REGISTER_END_OF_DAY_ENTITIES,
    });
  }

  async printMultipleEndOfDays(body: { ids: number[]; layout: string }): Promise<void> {
    return this.#dataAccess.create(
      {
        path: SOFTLINE_API_CASH_REGISTER_END_OF_DAY_PRINT,
      },
      body
    );
  }

  async getAllEndOfDaysByCashierId(cashierId: number): Promise<any[]> {
    return this.#dataAccess.get({
      path: SOFTLINE_API_CASH_REGISTER_END_OF_DAY_CASHIER,
      pathParams: { cashierId },
    });
  }

  async finalize(
    endOfDay: EndOfDayValidateResult,
    isOk: boolean,
    archiving = false
  ): Promise<void> {
    return this.#dataAccess.create(
      {
        path: `${SOFTLINE_API_CASH_REGISTER_END_OF_DAY_FINALIZE}/${isOk ? 'true' : 'false'}`,
        queryParams: { archiving },
      },
      endOfDay
    );
  }

  async delete(endOfDayId: number): Promise<void> {
    return this.#dataAccess.delete({
      path: SOFTLINE_API_CASH_REGISTER_END_OF_DAY_DELETE,
      pathParams: { endOfDayId },
    });
  }

  async validate(endOfDay: EndOfDay): Promise<EndOfDayValidateResult> {
    return this.#dataAccess.create(
      {
        path: SOFTLINE_API_CASH_REGISTER_END_OF_DAY_VALIDATE,
      },
      endOfDay
    );
  }

  async endOfDayTerminal(cashier: Cashier): Promise<unknown> {
    return this.#dataAccess.create(
      {
        path: SOFTLINE_API_CASH_REGISTER_END_OF_DAY_FINALIZE_TERMINAL,
      },
      cashier
    );
  }
}
